import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setNav } from '../actions';

import Header from '../components/header';
import '../style/style.css';

class App extends Component {
    componentDidMount() {
        this.props.setNav(this.props.location.pathname);
        window.addEventListener("resize-app", this.updateDimentions)
    }

    componentWillUnmount() {
       window.removeEventListener("resize-app", this.updateDimentions);
    }

    updateDimentions = () => {
        this.props.reSize(window.innerWidth, window.innerHeight)
    }

    renderHeader(){
        if ((this.props.location.pathname === "/" && this.props.authenticated) || this.props.location.pathname !== "/") {
            return (
                <div className="header-container">
                    <div className ="spacer-sm"></div>
                    <Header name= {this.props.app.name} navbaritems = {this.props.app.navbaritems}/>
                </div>
            )
        }
    }

    render() {
        var max_width;
        if ((this.props.location.pathname === "/" && this.props.authenticated) || this.props.location.pathname !== "/") {
            max_width = 1200;
        } else {
            max_width = window.innerWidth
        }
        var passMargin = 0;
        if (this.props.location.pathname === "/signup" || this.props.location.pathname === "/signin") {
            passMargin = 20
        }
        return (
          <div style={{ maxWidth: max_width }} className="App">
            {this.renderHeader()}
            <div style={{margin: passMargin}} className="App-children">
                {this.props.children}
            </div>
          </div>
        );
  }
}

function mapStateToProps(state) {
    return { app: state.app,
            authenticated: state.app.authenticated};

}

export default connect(mapStateToProps, {setNav})(App);



// WEBPACK FOOTER //
// ./src/pages/app.js